import { IonButton, IonCol, IonImg, IonRow } from '@ionic/react';
import React from 'react';
import { Link } from 'react-router-dom';
import HomeView from '../../constants/HomeView';
import { EXCH_SPORTS_MAP } from '../../constants/ExchangeEventTypes';
import {
  Card,
  CardActionArea,
  CardContent,
  Typography,
} from '@material-ui/core';
import VirtualImg from '../../assets/images/home/sports/virtual.webp';


const Images = HomeView.HOME_PAGE_IMAGES;
const Headings = HomeView.HOME_PAGE_HEADERS;

const SportsBookImages = [
  Images.cricket,
  Images.football,
  Images.tennis,
  Images.horseRacing,
  Images.greyHound,
];

const SportsBook = ( ) => {
  return (
    <>
      <div className="sports-grid">
        <IonRow className="sports">
          <IonCol size="12" class="sports-header">
            <div>
              <div className="sports-text">{Headings.sportsBook}</div>
              <div className="text-border-btm"></div>
            </div>
            <Link className="more-link" to="/exchange_sports">
              <IonButton
                color="primary"
                size="small"
                className="browse-all-btn"
              >
                Browse All
              </IonButton>
            </Link>
          </IonCol>
        </IonRow>

        <IonRow class="sports-book">
          {SportsBookImages.map((sport) =>
            (EXCH_SPORTS_MAP[sport.text.toLowerCase()]) !==
            0 ? (
              <IonCol
                sizeXs="4"
                sizeSm="4"
                sizeMd="2"
                sizeLg="2"
                class="sport"
                key={sport.text}
              >
                <Link to={sport.url} className="decoration-none">
                  <IonImg
                    className="grid-images sport-images"
                    src={sport.image}
                    alt={sport.text}
                    title={sport.text}
                  />
                  <Card key={sport.text} className="game-card sport-card">
                    <CardActionArea>
                      <CardContent className="dc-card-ctn">
                        <Typography gutterBottom className="game-name">
                          {sport.text.toUpperCase()}
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Link>
              </IonCol>
            ) : null
          )}

          {/* <IonCol
            sizeXs="4"
            sizeSm="4"
            sizeMd="2"
            sizeLg="2"
            class="sport"
            key={'virual'}
          >
            <Link to={`/virtual_sports`} className="decoration-none">
              <IonImg
                className="grid-images sport-images"
                src={VirtualImg}
                alt={'virual'}
                title={'virual'}
              />
              <Card key={'virual'} className="game-card sport-card">
                <CardActionArea>
                  <CardContent className="dc-card-ctn">
                    <Typography gutterBottom className="game-name">
                      {'VIRTUAL_SPORTS'}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Link>
          </IonCol> */}
        </IonRow>
      </div>
    </>
  );
};

export default SportsBook;
